<div class="wrapper mb-5">
    <div class="row align-items-center m-0" style="padding: 10px;">
        <img class="p-2" src="./assets/icons/arrow.svg">
        <span class="label-title ml-2 mr-3">Extrato</span>
    </div>
    <div class="component-box container-fluid">
        <div class="container-fluid pt-4">

            <div class="row">
                <div class="col-12" *ngIf="extractDetails">
                    <ul class="options-cadastro pl-0 float-left">
                        <li class="mr-3">Valor total: <b>{{ extractDetails.orderItemsTotalValue | currency:'BRL':true }}</b></li>
                        <li class="mr-3">Valor total de taxas: <b>{{ extractDetails.purchaseTotalFeeValue | currency:'BRL':true }}</b></li>
                        <li class="mr-3">Data Início: <b>{{ extractDetails.startDate | date: 'dd/MM/yyyy' }}</b></li>
                        <li>Data Fim: <b>{{ extractDetails.endDate | date: 'dd/MM/yyyy' }}</b></li>
                    </ul>
                </div>
                <div class="col-md-4 col-sm-12" *ngIf="extractDetails">
                    <ul class="options-cadastro pl-0 float-left">
                        <li>
                            <div *ngIf="exibirFiltro" (click)="exportExtractExcel()" class="list-select ml-2 my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span>Exportar Excel</span>
                                </button>
                            </div>
                        </li>
                    </ul>
                </div>
                <div class="col-md-8 col-sm-12 float-right text-right">
                    <ul class="options-cadastro float-right">
                        <li>
                            <div *ngIf="exibirFiltro && filtroOn" (click)="deleteFilter(filtro)" class="list-select ml-2
                                my-1">
                                <button _ngcontent-khv-c20="" class="list-select-delete" type="button">
                                    Apagar filtro
                                </button>
                            </div>
                        </li>
                        <li>
                            <div *ngIf="exibirFiltro" (click)="showFilter(filtro)" class="list-select ml-2
                                my-1">
                                <button _ngcontent-khv-c20="" class="list-select"  type="button">
                                    <span *ngIf="!filtroOn"><img src="assets/icons/filter.svg" style="height: 15px;"> Aplicar filtro</span>
                                    <span *ngIf="filtroOn"><img src="assets/icons/filter-purple.svg" style="height: 15px;"> Alterar filtro</span>
                                </button>
                            </div>
                        </li>
                        <li>
                            <div class="list-filter-show-item ml-2 my-1">
                                Mostrar:
                                <select (change)="showItemChanged($event.target.value)" class="ng-untouched ng-pristine ng-valid">
                                    <option _ selected="" value="10">10</option>
                                    <option value="25">25</option>
                                    <option value="50">50</option>
                                    <option value="100">100</option>
                                </select>
                            </div>
                        </li>
                    </ul>
                </div>
            </div>

            <div class="table-overflow">

                <div class="table-responsive"  *ngIf="totalItems > 0">
                    <table class="list-table table table-striped" id="dataTable" width="100%" cellspacing="0">
                        <thead>
                            <tr>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('purchaseId', sortOrder)
                                    ">
                                    Recarga
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('purchaseDate', sortOrder)
                                    ">
                                    Data da recarga
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('manager', sortOrder)
                                    ">
                                    Gestor
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('name', sortOrder)
                                    ">
                                    Nome
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('document', sortOrder)
                                    ">
                                    CPF
                                </th>
                                <th *ngIf="showColumnRegister" (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('register', sortOrder)
                                    ">
                                    {{ labelRegister }}
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('productName', sortOrder)
                                    ">
                                    Produto
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('orderItemValue', sortOrder)
                                    ">
                                    Valor
                                </th>
                                <th (click)="
                                        sortOrder = !sortOrder;
                                        orderBy('unit', sortOrder)
                                    ">
                                    Data de processamento
                                </th>
                                <th *ngIf="showColumnStatus" (click)="
                                    sortOrder = !sortOrder;
                                    orderBy('situation', sortOrder)
                                    ">
                                    {{ labelStatus }}
                                </th>
                                <th></th>
                            </tr>
                        </thead>
                        <tbody class="list-table-row">
                            <tr *ngFor="
                                let item of extractList
                                    | paginate
                                        : {
                                            itemsPerPage: showItem,
                                            currentPage: currentPage,
                                            totalItems: totalItems
                                        }
                            ">
                                <td class="clickable">
                                    {{ item.purchaseId }}
                                </td>
                                <td class="clickable">
                                    {{ item.purchaseDate | date: 'dd/MM/yyyy HH:mm' }}
                                </td>
                                <td class="clickable">
                                    {{ item.managerName }}
                                </td>
                                <td class="clickable">
                                    {{ item.collaboratorName }}
                                </td>
                                <td class="clickable" >
                                    <span *ngIf="item.collaboratorDocument || item.collaboratorDocument != null">{{ item.collaboratorDocument | cpf }}</span>
                                    <span *ngIf="!item.collaboratorDocument || item.collaboratorDocument == null"></span>
                                </td>
                                <td *ngIf="showColumnRegister"  class="clickable" >
                                    {{ item.collaboratorRegister }}
                                </td>
                                <td class="clickable" >
                                    {{ item.productName }}
                                </td>
                                <td class="clickable" >
                                    {{ item.orderItemValue | currency:'BRL':true}}
                                </td>
                                <td *ngIf="item.releaseDate != '0001-01-01T00:00:00'; else elseBlock" class="clickable" >
                                    {{ item.releaseDate | date: 'dd/MM/yyyy HH:mm' }}
                                </td>
                                <ng-template #elseBlock>
                                    <td>Sem data de processamento</td>
                                </ng-template>
                                <td *ngIf="showColumnStatus"  class="clickable">
                                    {{ item.statusDescription }}
                                </td>
                                <td>
                                    <div ngbDropdown class="d-inline-block
                                        menu-option" placement="left">
                                        <button class="dropdown-button" id="dropdown-menu" ngbDropdownToggle>
                                            <img src="assets/icons/menu.png" />
                                        </button>
                                        <div ngbDropdownMenu aria-labelledby="dropdown-menu" class="p-0 m-0">
                                            <section class="custom-context-menu">
                                            </section>
                                        </div>
                                    </div>
                                </td>
                            </tr>
                        </tbody>
                    </table>



                    <div class="page-custom mt-2">
                        <pagination-controls (pageChange)="getExtract($event)" responsive="true" previousLabel="" nextLabel=""></pagination-controls>
                    </div>
                </div>
                <div *ngIf="filtroOn && totalItems == 0" class="text-center mb-4">
                    <h5>
                        Não encontramos um extrato para o seu filtro!
                    </h5>
                </div>

                <div *ngIf="!filtroOn && totalItems == 0" class="text-center mb-4">
                    <h5>
                        Faça uma busca com filtro para visualizar seu extrato!
                    </h5>
                </div>
            </div>
        </div>
    </div>
</div>

<!--Modal do Filtro-->
<ng-template #filtro let-modal>
        <div class="col-12 modal-header clean-modal-header">
            <div class="col-md-12">
                <h5 class="clean-modal-title">Aplicar filtro</h5>
            </div>
        </div>
            <div class="row col-12 clean-modal-content">
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                      <div class="custom-filter-input-container">
                        <mat-form-field>
                            <input [formControl]="startDateCtrl" id="startDate" matInput [matDatepicker]="startDate" placeholder="Data Início" [value]="filtroDataInicio"/>
                            <mat-datepicker-toggle matSuffix [for]="startDate"></mat-datepicker-toggle>
                            <mat-datepicker #startDate></mat-datepicker>
                            <mat-error *ngIf="startDateCtrl.hasError('required')">Escolha uma data ou período</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <mat-form-field>
                            <input [formControl]="endDateCtrl" id="endDate" matInput [matDatepicker]="endDate" placeholder="Data Fim" [value]="filtroDataFim" />
                            <mat-datepicker-toggle matSuffix [for]="endDate"></mat-datepicker-toggle>
                            <mat-datepicker #endDate></mat-datepicker>
                            <mat-error *ngIf="endDateCtrl.hasError('required')">Escolha uma data ou período</mat-error>
                        </mat-form-field>
                    </div>
                </div>
                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <mat-form-field>
                            <mat-select [formControl]="datePeriodCtrl" id="produto" placeholder="Período" [value]="filtroPeriodo">
                                <mat-option>Selecione um período</mat-option>
                                <mat-option *ngFor="let item of parametersList" [value]="item.id">
                                    {{item.nome}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <mat-form-field>
                            <mat-select [formControl]="productsCtrl" id="produto" [multiple]="true" placeholder="Produtos" [value]="filtroProduto">
                                <mat-option *ngFor="let item of productList" [value]="item.produtoId">
                                    {{item.descricaoProduto}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <mat-form-field>
                            <mat-select [formControl]="collaboratorsServerSideCtrl" [multiple]="true" placeholder="Favorecidos" [value]="filtroColaborador">
                                <!-- place ngx-mat-select-search inside mat-option to allow opening without initial selection -->
                                <mat-option>
                                  <ngx-mat-select-search
                                  [formControl]="collaboratorsServerSideFilteringCtrl"
                                  [searching]="searching"
                                  placeholderLabel="Procure um favorecido"
                                  noEntriesFoundLabel="Nenhum favorecido encontrado"></ngx-mat-select-search>
                                </mat-option>
                                <mat-option *ngFor="let item of collaboratorsFiltered | async" [value]="item.id">
                                  {{item.name}}
                                </mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>

                <div *ngIf="showColumnStatus" class="col-lg-4 col-md-6 col-sm-12 my-4">
                    <div class="custom-filter-input-container">
                        <mat-form-field>
                            <mat-select [formControl]="statusCtrl" id="status" placeholder="{{ labelStatus }}" [value]="filtroSituacao">
                                <mat-option>Selecione uma situação</mat-option>
                                <mat-option [value]="1">Aguardando processamento</mat-option>
                                <mat-option [value]="2">Processado</mat-option>
                                <mat-option [value]="3">Não Processado</mat-option>
                                <mat-option [value]="4">Aguardando reprocessamento</mat-option>
                                <mat-option [value]="5">Cancelado</mat-option>
                            </mat-select>
                        </mat-form-field>
                    </div>
                </div>
            </div>
            <div class="col-12 clean-modal-footer">
                <button class="custom-filter-button custom-filter-button-just" type="button" (click)="applyFilter();" ngbAutofocus>
                    Aplicar
                </button>
            </div>
</ng-template>
